import { combineReducers } from 'redux';
import collections, {
  CollectionsInitialStateType,
} from './collections.reducers';
import download, { DownloadInitialStateType } from './download.reducers';
import errors, { ErrorsState } from './errors.reducers';
import mindItems, { MindItemState } from './mindItems.reducers';
import upgradeCodes, { UpgradeCodeState } from './upgradeCodes.reducers';
import pinned, { PinnedInitialStateType } from './pinned.reducers';
import products, { ProductState } from './products.reducers';
import user, { UserInitialStateType } from './user.reducers';
import dashboard, { DashboardInitialStateType } from './dashboard.reducers';
import licenceModels, {
  LicenceModelsStateType,
} from './licenceModels.reducers';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import search, { SearchInitialStateType } from './search.reducers';
import publishers, { PublisherState } from './publishers.reducers';
import schoolTypes, { SchoolTypeState } from './schoolTypes.reducers';
import aiFilterValues, { AiFilterValuesState } from './aiFilterValues.reducers';
import lernsets, { LernsetsState } from './lernsets.reducers';
import courses, { CourseState } from './courses.reducers';
import aiAssistant, { AIAssistantState } from './aiAssistant.reducers';

export type StoreItem<T> = {
  data?: T;
  status: AsyncActionStatus;
  error?: string;
};

export interface StoreType {
  collections: CollectionsInitialStateType;
  courses: CourseState;
  dashboard: DashboardInitialStateType;
  download: DownloadInitialStateType;
  errors: ErrorsState;
  licenceModels: LicenceModelsStateType;
  mindItems: MindItemState;
  upgradeCodes: UpgradeCodeState;
  pinned: PinnedInitialStateType;
  products: ProductState;
  publishers: PublisherState;
  schoolTypes: SchoolTypeState;
  aiFilterValues: AiFilterValuesState;
  search: SearchInitialStateType;
  user: UserInitialStateType;
  lernsets: LernsetsState;
  aiAssistant: AIAssistantState;
}

export default combineReducers<StoreType>({
  collections,
  courses,
  dashboard,
  download,
  errors,
  licenceModels,
  mindItems,
  upgradeCodes,
  pinned,
  products,
  schoolTypes,
  aiFilterValues,
  search,
  publishers,
  user,
  lernsets,
  aiAssistant
});
